export default __webpack_public_path__ + "static/media/logo.3ae09ba1.svg";